import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

export interface ChoiceOption {
  value: any;
  label: string; // clé i18n (ou texte brut — ngx-translate renvoie la clé si absente)
  icon?: string; // emoji optionnel (utile en variante « cards »)
}

/**
 * Sélecteur de choix générique et réutilisable.
 * - variante `chips` : pills sur une ligne (ex. ensoleillement, exposition, sol…).
 * - variante `cards` : grille de cartes illustrées (ex. type de zone).
 * - `deselectable` : un re-clic sur l'option active la désélectionne (choix optionnel).
 * Two-way binding via `[(value)]`.
 */
@Component({
  selector: 'vw-choice-selector',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './choice-selector.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './choice-selector.component.scss',
})
export class ChoiceSelectorComponent {
  @Input() options: ChoiceOption[] = [];
  @Input() value: any;
  @Output() valueChange = new EventEmitter<any>();
  @Input() variant: 'chips' | 'cards' = 'chips';
  @Input() columns = 3;
  @Input() deselectable = false;

  select(option: ChoiceOption): void {
    const next =
      this.deselectable && this.value === option.value ? undefined : option.value;
    this.value = next;
    this.valueChange.emit(next);
  }
}
